module.exports = __webpack_public_path__ + "static/media/truck-palladium.3123b324.png";